import React, { useEffect, useState } from 'react';
import * as yup from 'yup';
import axios from 'axios';
import { useHistory, useLocation, useParams } from 'react-router';
import { ItemResponse, SaveResponse } from 'helpers/interfaces';

interface IContext {
    isSaving: boolean
    isLoading: boolean,
    ticketStatus: ITicketState

    saveTicketStatus: (ticket: ITicketState) => Promise<void>
}

export let ticketStatusSchema = yup.object({
    ticketStateId: yup.string().default(''),
    code: yup.string().default('').required(),
    name: yup.string().default('').required(),
    customerVisibleStatus: yup.string().default('').required(),
    sortOrder: yup.number().default(1).required(),
    isResolved: yup.boolean().default(false),
    isInitialStatus: yup.boolean().default(false),
    hasAutomaticUpdates: yup.boolean().default(false),
});

export type ITicketState = yup.InferType<typeof ticketStatusSchema>;

export let ticketStatusContext = React.createContext({} as IContext);

let { Provider } = ticketStatusContext;

let TicketStateProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    let history = useHistory();

    let { id } = useParams<{ id: string }>();
    let location = useLocation();

    let isNew = location.pathname.includes("/addnew");

    let [isSaving, setSaving] = useState(false);
    let [isLoading, setLoading] = useState<boolean>(isNew === false);
    let [ticketStatus, setTicketStatus] = useState(ticketStatusSchema.getDefault())



    useEffect(() => {
        if (isNew === false)
            getTicketStatus();

    }, [id, isNew])

    let getTicketStatus = async () => {
        try {
            let res = await axios.get<ItemResponse<ITicketState>>('/api/TicketStatus/GetTicketStatus', { params: { id } });

            let { item } = res.data;
            setTicketStatus(item);
            setLoading(false);

        } catch (err) { }
        finally {
            setLoading(false);
        }
    }

    let saveTicketStatus = async (ticketState: ITicketState) => {
        try {
            setSaving(true);
            await axios.post<SaveResponse>('/api/TicketStatus/SaveTicketStatus', ticketState);
            history.goBack();
        } catch (err) {
        } finally {
            setSaving(false);
        }
    }
    return (
        <Provider
            value={{
                isSaving,
                saveTicketStatus,
                ticketStatus,
                isLoading
            }}
        >
            {children}
        </Provider>
    )
}

export default TicketStateProvider;